export const env = { ...window.ENV };
